import { Box } from "@mui/material"

function Loader() {
  return (
    <Box
      sx={{
        inset: "0",
        zIndex: "9999",
        display: "grid",
        position: "fixed",
        bgcolor: "#00000080",
        placeContent: "center",
      }}
    >
      <span className="loader"></span>
    </Box>
  )
}

export default Loader